// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subDays as fn } from "../subDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subDaysWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subDaysWithOptions;
